import { render } from "./IziCard.vue?vue&type=template&id=3eb48f04&scoped=true"
import script from "./IziCard.vue?vue&type=script&lang=ts"
export * from "./IziCard.vue?vue&type=script&lang=ts"

import "./IziCard.vue?vue&type=style&index=0&id=3eb48f04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3eb48f04"

export default script